import React, { useState } from "react";
import { Link } from "react-router-dom";
import cl from "./Navbar.module.css";
import gl from "../../../styles/Global.module.css";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const toggleMenu = () => {
    setOpen((prev) => !prev);
  };
  const handlePress = (e) => {
    e.preventDefault(); // Предотвращаем возможное двойное срабатывание
    console.log("burger handlePress");

    toggleMenu();
  };
  return (
    <nav className={cl.navbar}>
      <div className={cl.menuIconWrapper}>
        <div className={cl.navbarHeader}>
          <button
            className={`${cl.menuIcon} ${gl.grow_on_hover}`}
            // onClick={handlePress}
            onMouseDown={handlePress}
            onTouchStart={handlePress}>
            ☰
          </button>
        </div>

        <ul className={`${cl.navbarLinks} ${open ? cl.open : ""}`}>
          <li className={gl.grow_on_hover}>
            <Link to="/" onClick={() => setOpen(false)}>
              Схема
            </Link>
          </li>
          <li className={gl.grow_on_hover}>
            <Link to="/fit" onClick={() => setOpen(false)}>
              Расход
            </Link>
          </li>
          {/* <li className={gl.grow_on_hover}>
            <Link to="/testgchart" onClick={() => setOpen(false)}>
              Test
            </Link>
          </li>
          <li className={gl.grow_on_hover}>
            <Link to="/gchart" onClick={() => setOpen(false)}>
              Чарты
            </Link>
          </li>
          <li className={gl.grow_on_hover}>
            <Link to="/chart" onClick={() => setOpen(false)}>
              Графики
            </Link>
          </li>
          <li className={gl.grow_on_hover}>
            <Link to="/google" onClick={() => setOpen(false)}>
              Гугл Графики
            </Link>
          </li>
          <li className={gl.grow_on_hover}>
            <Link to="/vars" onClick={() => setOpen(false)}>
              Vars
            </Link>
          </li>
          <li className={gl.grow_on_hover}>
            <Link to="/status" onClick={() => setOpen(false)}>
              Status
            </Link>
          </li>
           <li className={gl.grow_on_hover}>
            <Link to="/about" onClick={() => setOpen(false)}>
              About
            </Link>
          </li> 
          <li className={gl.grow_on_hover}>
            <Link to="/posts" onClick={() => setOpen(false)}>
              Check
            </Link>
          </li>
          <li className={gl.grow_on_hover}>
            <Link to="/noway" onClick={() => setOpen(false)}>
              404
            </Link>
          </li> */}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
